import React from 'react'

import { TableDataLock } from './component'

const DataLock: React.FC = () => {
  return (
    <TableDataLock />
  )
}

export default DataLock
